export function showCollapse(id, forceCreate = true)
{
    let collapse = getCollapse(id, forceCreate);
    if (collapse) collapse.show();
}

export function hideCollapse(id)
{
    let collapse = getCollapse(id);
    if (collapse) collapse.hide();
}

export function hideCollapseBySelector(selector, forceCreate = true)
{
    let collapse = getCollapseBySelector(selector, forceCreate);
    if (collapse) collapse.hide();
}

export function getCollapse(id, forceCreate = true)
{
    let collapse = document.getElementById(id);

    if (!collapse) return null;

    if (forceCreate) return Collapse.getOrCreateInstance(collapse);
    else return Collapse.getInstance(collapse);
}

export function getCollapseBySelector(selector, forceCreate = true)
{
    let collapse = document.querySelector(selector);

    if (!collapse) return null;

    if (forceCreate) return Collapse.getOrCreateInstance(collapse);
    else return Collapse.getInstance(collapse);
}